import clsx from 'clsx'
import {KTIcon} from '../../../helpers'
import {HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import React from "react";
import {useAuth} from "../../../../app/modules/auth";
import {useThemeMode, systemMode} from "../../../partials/layout/theme-mode/ThemeModeProvider";

const itemClass = 'ms-1 ms-lg-3';
const userAvatarClass = 'symbol-35px symbol-md-40px';

const Navbar = () => {
    const {currentUser} = useAuth();
    const {mode} = useThemeMode();
    const isDarkMode = mode === 'dark' || (mode === 'system' && systemMode === 'dark');

    return (
        <div className='app-navbar flex-grow-1 d-flex align-items-center'>
            <div className="align-self-center p-3 me-auto">

            </div>

            <div className={clsx('app-navbar-item align-items-stretch ms-auto', itemClass)}>
                <Search/>
            </div>

            <div className={clsx('app-navbar-item', itemClass)}>
                <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')}/>
            </div>

            <div className={clsx('app-navbar-item', itemClass)}>
                <div
                    className={clsx('cursor-pointer symbol', userAvatarClass)}
                    data-kt-menu-trigger="{default: 'click'}"
                    data-kt-menu-attach='parent'
                    data-kt-menu-placement='bottom-end'
                    style={{
                        backgroundColor: isDarkMode ? 'rgba(0, 158, 247, 0.1)' : 'rgba(0, 158, 247, 0.1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: isDarkMode ? '1px solid rgba(0, 158, 247, 0.2)' : '1px solid rgba(0, 158, 247, 0.2)'
                    }}
                >
                    <KTIcon
                        iconName='profile-circle'
                        iconType='duotone'
                        className='fs-2x text-primary'
                    />
                    <style>{`
                        .symbol .ki-duotone.ki-profile-circle { color: #009ef7; }
                        .symbol .ki-duotone.ki-profile-circle .path1 { opacity: 0.3; }
                        .symbol .ki-duotone.ki-profile-circle .path2 { opacity: 1; }
                        .symbol .ki-duotone.ki-profile-circle .path3 { opacity: 0.7; }
                    `}</style>
                </div>
                <HeaderUserMenu/>
            </div>
        </div>
    );
};

export {Navbar}
